import { Entity } from '@/interfaces/entity';

export class Vendor implements Entity{
    id: string;
    email: string;
    vendor_name: string;
    vendor_id: string;
    address: string;
    contact_no: string;
    org_id: string;
    first_time_logged_in: string;

    constructor(id='', email='',vendor_name = "", vendor_id = "", address = "", contact_no = "", org_id="", first_time_logged_in=""){
        this.id = id;
        this.email = email;
        this.vendor_name = vendor_name;
        this.vendor_id = vendor_id;
        this.address = address;
        this.contact_no = contact_no;
        this.org_id = org_id;
        this.first_time_logged_in = first_time_logged_in;
    }
}